export default {"src":"/_next/static/image/src/assets/icons/filter-icons/pool.16a8992d234493629f5df3ae7874a3e5.svg","height":32,"width":32};